module.exports = __webpack_public_path__ + "static/media/loading.b012677b.gif";